import { i18n } from "@/boot/i18n";
import CustomerService from "@/services/customer";
import ErrorHandler from "@/tools/errorHandler";
import * as types from "./mutationTypes";

export default {
  initState({ commit }) {
    commit(types.SET_CUSTOMERS, []);
    commit(types.SET_TOTAL_CUSTOMERS, 0);
  },
  clearState({ commit, dispatch }) {
    commit(types.CLEAR_CUSTOMERS);
    commit(types.CLEAR_TOTAL_CUSTOMERS);
    commit(types.CLEAR_NOTES);
    commit(types.CLEAR_CUSTOMER_METADATAS);
    dispatch("metadata/clearMetadatas", null, { root: true });
    dispatch("blockrule/clearBlockrule", null, { root: true });
  },
  setCustomersSuccess({ commit }, { customers, total }) {
    commit(types.SET_CUSTOMERS, customers);
    commit(types.SET_TOTAL_CUSTOMERS, total);
  },
  setCustomerMetadatasSuccess({ commit }, customersMetadata) {
    commit(types.SET_CUSTOMER_METADATAS, customersMetadata);
  },
  async setNotesSuccess({ commit, dispatch }, notes) {
    for (let i = 0; i < notes.length; i++) {
      const note = notes[i];
      const user = await dispatch("user/getOne", note.user_uuid, { root: true });
      note.user = user.name;
    }
    commit(types.SET_NOTES, notes);
  },
  async getAll({ rootState, dispatch }, pagination) {
    try {
      const response = await CustomerService.getAll(rootState.organization.organization.uuid, pagination);
      if (response.data.data.customers) {
        dispatch("setCustomersSuccess", {
          customers: response.data.data.customers,
          total: response.data.data.total_rows
        });
      } else {
        dispatch("setCustomersSuccess", {
          customers: [],
          total: 0
        });
      }
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async delete({ rootState, dispatch, commit }, customerUUID) {
    try {
      await CustomerService.delete(rootState.organization.organization.uuid, customerUUID);
      commit(types.REMOVE_CUSTOMER, customerUUID);
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async getAllNotes({ rootState, dispatch }, customerUuid) {
    try {
      const response = await CustomerService.getAllNotes(rootState.organization.organization.uuid, customerUuid);
      if (response.data.data) {
        dispatch("setNotesSuccess", response.data.data);
      }
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async deleteNote({ rootState, dispatch }, { customerUUID, noteUUID }) {
    try {
      await CustomerService.deleteNotes(rootState.organization.organization.uuid, customerUUID, noteUUID);
      dispatch("removeNote", noteUUID);
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async createNote({ rootState, dispatch }, { customerUUID, text }) {
    try {
      const response = await CustomerService.createNotes(rootState.organization.organization.uuid, customerUUID, text);
      if (response.data.data) {
        dispatch("addNote", response.data.data);
      }
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async getCustomerMetadatas({ rootState, dispatch }, customerUUID) {
    try {
      const response = await CustomerService.getCustomerMetadata(
        rootState.organization.organization.uuid,
        customerUUID
      );
      if (response.data.data) {
        dispatch("setCustomerMetadatasSuccess", response.data.data);
      } else {
        dispatch("setCustomerMetadatasSuccess", []);
      }
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  async updateCustomerMetadata({ rootState, dispatch }, { customerUUID, metadataUUID, value }) {
    try {
      value = value.toString();
      await CustomerService.updateCustomerMetadata(
        rootState.organization.organization.uuid,
        customerUUID,
        metadataUUID,
        value
      );
      dispatch("ui/showToastSuccess", i18n.t("customer.messages.update_metadata"), { root: true });
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
    }
  },
  unsubscribe(context, { organizationUUID, customerUUID, distributionUUID, data }) {
    return CustomerService.unsubscribe({ organizationUUID, customerUUID, distributionUUID, data });
  },
  addNote({ commit, rootState }, note) {
    note.user = rootState.profile.profile.name;
    commit(types.ADD_NOTE, note);
  },
  removeNote({ commit }, uuid) {
    commit(types.REMOVE_NOTE, uuid);
  }
};
